module.exports = __webpack_public_path__ + "img/badge-network-silver-brightbg.051a43e3.svg";